// 全局参数配置
// console.log('process.en', process.env);
export default {
  NODE_ENV: process.env.NODE_ENV,
  BASE_URL: process.env.BASE_URL,
  PORTAL_DOMAIN: process.env.PORTAL_DOMAIN,
  ENVIRONMENT: process.env.ENVIRONMENT
};



// WEBPACK FOOTER //
// ./src/global/global.js